enum ApiType {
  WIX_WIZ = 'WixWiz',
  VIDEO_MAKER_ASSETS = 'VideoMakerAssets',
  VIDEO_MAKER_VIDEO = 'VideoMakerVideo',
  ADI = 'Adi',
}

enum ErrorType {
  UNKNOWN = 'unknown',
  SITE_UNKNOWN = 'site unknown',
  UNAUTHORIZED = 'unauthorized',
  UNHANDLED = 'unhandled',
  NOT_FOUND = 'not found',
  MEDIA = 'invalid media',
  MISSING_DATA = 'missing data',
}

interface IResponse {
  status?: number;
  data?: any;
}

interface IResponseError extends Error {
  response?: IResponse;
}

class VmafError extends Error {
  type: ErrorType;
  rawError: Error;

  constructor(message: string, type: ErrorType, rawError?: Error) {
    super(message);

    this.type = type;
    this.rawError = rawError;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, VmafError);
    }
  }
}

interface IErrorNormalizer {
  normalizeToVmafError(e: any): VmafError;
}

export { ApiType, ErrorType, VmafError, IErrorNormalizer, IResponseError };
